(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("string-template-parser"), require("core-js/es7/object"));
	else if(typeof define === 'function' && define.amd)
		define("ngx-translate-parser-plural-select", ["string-template-parser", "core-js/es7/object"], factory);
	else if(typeof exports === 'object')
		exports["ngx-translate-parser-plural-select"] = factory(require("string-template-parser"), require("core-js/es7/object"));
	else
		root["ngx-translate-parser-plural-select"] = factory(root["string-template-parser"], root["core-js/es7/object"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var string_template_parser_1 = __webpack_require__(2);
__webpack_require__(3);
var QUOTED_STRING_TEST = function (remainingString) { return remainingString.charAt(0) === '{'; };
var QUOTED_STRING_GET_AND_ADVANCE = function (remainingString, advance) {
    var currentPosition = 1;
    var depth = 1;
    while (depth > 0 && currentPosition < remainingString.length) {
        if (remainingString[currentPosition] === '\\') {
            currentPosition += 2;
            continue;
        }
        if (remainingString[currentPosition] === '{') {
            depth++;
        }
        if (remainingString[currentPosition] === '}') {
            depth--;
        }
        currentPosition++;
    }
    var result = remainingString.substr(0, currentPosition);
    advance(currentPosition);
    return result;
};
var parseI18NString = string_template_parser_1.parseStringTemplateGenerator({
    VARIABLE_START: /^{\s*/,
    VARIABLE_END: /^\s*}/,
    PIPE_START: /^\s*,\s*/,
    PIPE_PARAMETER_START: /^\s*,\s*/,
    QUOTED_STRING_IN_PARAMETER_TEST: QUOTED_STRING_TEST,
    QUOTED_STRING_IN_PARAMETER_GET_AND_ADVANCE: QUOTED_STRING_GET_AND_ADVANCE
});
var parseI18NParameter = string_template_parser_1.parseStringTemplateGenerator({
    VARIABLE_START: /^{/,
    VARIABLE_END: /^}/,
    PIPE_START: /^$/,
    PIPE_PARAMETER_START: /^$/,
    QUOTED_STRING_TEST: QUOTED_STRING_TEST,
    QUOTED_STRING_GET_AND_ADVANCE: QUOTED_STRING_GET_AND_ADVANCE,
    QUOTED_STRING_IN_PARAMETER_TEST: QUOTED_STRING_TEST,
    QUOTED_STRING_IN_PARAMETER_GET_AND_ADVANCE: QUOTED_STRING_GET_AND_ADVANCE
});
// const I18N_PIPES_FULL = (
// 	variables: {[varName: string]: any},
// 	interpolate: (variable: string, params?: any) => string
// ): {[pipeName: string]: PipeFunction} => ({
// 	plural: (value: string, [parameter]: string[]) => {
// 		const parsedParameter = parseI18NParameter(parameter);
// 		const options = parsedParameter.literals.map(literal => literal.trim()).slice(0, parsedParameter.literals.length - 1);
// 		const values = parsedParameter.variables.map(variable => interpolate(variable.name, variables));
// 		const mapper: {[option: string]: string} = options.reduce((map, option, index) => ({...map, [option.charAt(0) === '=' ? option.slice(1).trim() : option.trim()]: values[index]}), {});
// 		const numValue = +value;
// 		if (mapper.hasOwnProperty(numValue.toString())) {
// 			return mapper[value];
// 		}
// 		if (numValue === numValue) {
// 			const lastDigit: {[digit: number]: string[]} = {
// 				0: ['zero'],
// 				1: ['one'],
// 				2: ['two', 'few'],
// 				3: ['three', 'few'],
// 				4: ['four', 'few'],
// 				5: ['five', 'many'],
// 				6: ['six', 'many'],
// 				7: ['seven', 'many'],
// 				8: ['eight', 'many'],
// 				9: ['nine', 'many']
// 			};
// 			return mapper.hasOwnProperty(value)
// 				? mapper[value]
// 				: [
// 				...(numValue >= 10 && numValue < 20) ? ['many'] : lastDigit[numValue % 10] || ['many'],
// 				...(numValue >= 20) ? ['many'] : [], 'other'
// 			].filter(key => mapper.hasOwnProperty(key)).map(key => mapper[key])[0] || '';
// 		}
// 		return mapper['other'] == null ? '' : mapper['other'];
// 	},
// 	select: (value: string, [parameter]: string[]) => {
// 		const parsedParameter = parseI18NParameter(parameter);
// 		const options = parsedParameter.literals.map(literal => literal.trim()).slice(0, parsedParameter.literals.length - 1);
// 		const values = parsedParameter.variables.map(variable => evaluateI18NString(variable.name, variables, getValue));
// 		const mapper: {[option: string]: string} = options.reduce((map, option, index) => ({...map, [option.trim()]: values[index]}), {});
// 		return mapper[value] == null ? '' : mapper[value];
// 	}
// });
var I18N_PIPES = {
    plural: function (value, options, values) {
        options = options.map(function (option) { return option.trim(); }).slice(0, options.length - 1);
        var mapper = options.reduce(function (map, option, index) {
            return (__assign({}, map, (_a = {}, _a[option.charAt(0) === '=' ? option.slice(1).trim() : option.trim()] = values[index], _a)));
            var _a;
        }, {});
        var numValue = +value;
        if (mapper.hasOwnProperty(numValue.toString())) {
            return mapper[value];
        }
        if (numValue === numValue) {
            var lastDigit = {
                0: ['zero'],
                1: ['one'],
                2: ['two', 'few'],
                3: ['three', 'few'],
                4: ['four', 'few'],
                5: ['five', 'many'],
                6: ['six', 'many'],
                7: ['seven', 'many'],
                8: ['eight', 'many'],
                9: ['nine', 'many']
            };
            return mapper.hasOwnProperty(value)
                ? mapper[value]
                : ((numValue >= 10 && numValue < 20) ? ['many'] : lastDigit[numValue % 10] || ['many']).concat((numValue >= 20) ? ['many'] : [], [
                    'other'
                ]).filter(function (key) { return mapper.hasOwnProperty(key); }).map(function (key) { return mapper[key]; })[0] || '';
        }
        return mapper['other'] == null ? '' : mapper['other'];
    },
    select: function (value, options, values) {
        options = options.map(function (option) { return option.trim(); }).slice(0, options.length - 1);
        var mapper = options.reduce(function (map, option, index) {
            return (__assign({}, map, (_a = {}, _a[option.trim()] = values[index], _a)));
            var _a;
        }, {});
        return mapper[value] == null ? '' : mapper[value];
    }
};
var TranslateICUCustomParser = /** @class */ (function () {
    function TranslateICUCustomParser(additionalPipes) {
        this.additionalPipes = additionalPipes;
        this.pipeEntries = [];
        this.pipeEntries = Object.entries(__assign({}, additionalPipes || {}, I18N_PIPES));
    }
    TranslateICUCustomParser.prototype.getPipes = function (variables) {
        var _this = this;
        return this.pipeEntries
            .map(function (_a) {
            var pipeName = _a[0], pipe = _a[1];
            return (_b = {}, _b[pipeName] = function (value, _a) {
                var parameter = _a[0];
                var parsedParameter = parseI18NParameter(parameter);
                var options = parsedParameter.literals;
                var values = parsedParameter.variables.map(function (variable) { return _this.interpolate(variable.name, variables); });
                return pipe(value, options, values);
            }, _b);
            var _b;
        })
            .reduce(function (acc, crt) { return (__assign({}, acc, crt)); }, {});
    };
    TranslateICUCustomParser.prototype.interpolate = function (expr, params) {
        var _this = this;
        var result = typeof expr === 'function'
            ? expr(params)
            : string_template_parser_1.evaluateParsedString(parseI18NString(expr), params, this.getPipes(params), function (variableName) { return _this.getValue(params, variableName); });
        if (!result) {
            result = expr;
        }
        return result;
    };
    TranslateICUCustomParser.prototype.isDefined = function (value) {
        return typeof value !== 'undefined' && value !== null;
    };
    TranslateICUCustomParser.prototype.getValue = function (target, key) {
        var keys = key.split('.');
        key = '';
        do {
            key += keys.shift();
            if (this.isDefined(target) && this.isDefined(target[key]) && (typeof target[key] === 'object' || !keys.length)) {
                target = target[key];
                key = '';
            }
            else if (!keys.length) {
                target = undefined;
            }
            else {
                key += '.';
            }
        } while (keys.length);
        return target;
    };
    return TranslateICUCustomParser;
}());
exports.TranslateICUCustomParser = TranslateICUCustomParser;
var TranslateICUParser = /** @class */ (function (_super) {
    __extends(TranslateICUParser, _super);
    function TranslateICUParser() {
        return _super.call(this, {}) || this;
    }
    return TranslateICUParser;
}(TranslateICUCustomParser));
exports.TranslateICUParser = TranslateICUParser;
// TODO: make these actual tests
// const parser = new TranslateICUParser({
// 	'?': (value: any, parameters: string[], options: string[]) => {
// 		parameters = parameters.map(option => option.trim()).slice(0, parameters.length - 1);
// 		const mapper: {[option: string]: string} = parameters.reduce((map, parameter, index) => ({...map, [parameter.trim()]: options[index]}), {});
// 		console.dir({value, parameters, options, mapper}, {depth: 10});
// 		return mapper[value] == null ? mapper[''] : mapper[':'];
// 	}
// });
// console.log(parser.interpolate('hi', {}));
// console.log(parser.interpolate('hi {name}', {name: 'Yogi'}));
// console.log(parser.interpolate('hi {name, ?, {{name}} : {mysterious person}', {}));
// console.log(parser.interpolate('hi {name, ?, {{name}} : {mysterious person}', {name: 'Yogi'}));
//
// console.log(parser.interpolate('this is {numPeople, plural, =0 {no one} =1 {someone} other {everyone}', {numPeople: '0'}));
// console.log(parser.interpolate('this is {numPeople, plural, =0 {no one} =1 {someone} other {everyone}', {numPeople: '1'}));
// console.log(parser.interpolate('this is {numPeople, plural, =0 {no one} =1 {someone} other {everyone}', {numPeople: '2'}));
// console.log(parser.interpolate('this is {gender, select, m {a man} f {a woman}', {gender: 'm'}));
// console.log(parser.interpolate('this is {gender, select, m {a man} f {a woman}', {gender: 'f'}));
// console.log(parser.interpolate('this is {gender, select, m {a man} f {a woman}', {gender: 'n'}));
// console.log(parser.interpolate('this is {numPeople, plural, =0 {no one} =1 {{gender, select, m {a man} f {a woman}}} other {everyone}}', {numPeople: '0', gender: 'm'}))
// console.log(parser.interpolate('this is {numPeople, plural, =0 {no one} =1 {{gender, select, m {a man} f {a woman}}} other {everyone}}', {numPeople: '0', gender: 'f'}))
// console.log(parser.interpolate('this is {numPeople, plural, =0 {no one} =1 {{gender, select, m {a man} f {a woman}}} other {everyone}}', {numPeople: '1', gender: 'm'}))
// console.log(parser.interpolate('this is {numPeople, plural, =0 {no one} =1 {{gender, select, m {a man} f {a woman}}} other {everyone}}', {numPeople: '1', gender: 'f'}))
// console.log(parser.interpolate('this is {numPeople, plural, =0 {no one} =1 {{gender, select, m {a man} f {a woman}}} other {everyone}}', {numPeople: '2', gender: 'm'}))
// console.log(parser.interpolate('this is {numPeople, plural, =0 {no one} =1 {{gender, select, m {a man} f {a woman}}} other {everyone}}', {numPeople: '2', gender: 'f'}))
//
// console.log(parser.interpolate('{n, plural, zero {zero} five {five} few {few} many {many}', {n: '0'}));
// console.log(parser.interpolate('{n, plural, zero {zero} five {five} few {few} many {many}', {n: '1'}));
// console.log(parser.interpolate('{n, plural, zero {zero} five {five} few {few} many {many}', {n: '2'}));
// console.log(parser.interpolate('{n, plural, zero {zero} five {five} few {few} many {many}', {n: '3'}));
// console.log(parser.interpolate('{n, plural, zero {zero} five {five} few {few} many {many}', {n: '4'}));
// console.log(parser.interpolate('{n, plural, zero {zero} five {five} few {few} many {many}', {n: '5'}));
// console.log(parser.interpolate('{n, plural, zero {zero} five {five} few {few} many {many}', {n: '10'}));
// console.log(parser.interpolate('{n, plural, zero {zero} five {five} few {few} many {many}', {n: '20'}));
// console.log(parser.interpolate('{n, plural, zero {zero} five {five} few {few} many {many}', {n: '25'}));
// console.log(parser.interpolate('{n, plural, zero {zero} few {few} many {many}', {n: '25'}));


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("string-template-parser");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("core-js/es7/object");

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js